<template>
    <b-row class="mt-5">
      <b-col cols="12" sm="6">
        <v-select id="worker_data"
                  class="mt-3 p-0"
                  label="name_cc_sharp_id"
                  placeholder="Búscar empleado por nombre o cédula"
                  v-model="selected_employee"
                  :options="getEmployeesBySearch"
                  :loading="processing_employees_by_search"
                  @search="searchEmployee"
                  @input="selectEmployee">
          <template slot="no-options">
            No se encontro ningun trabajador
          </template>
        </v-select>
      </b-col>
    </b-row>
</template>

<script>
import controller from './controller'
const { script } = controller()
export default script
</script>

<style
    lang="scss"
    src="./styles.scss" />